import { LeasingCalculatorSharedFormProps } from '../common/LeasingCalculatorData';
import {
  ContentWrapper,
  RowContainer,
  CalculatorContainer,
  EksDisclaimerContainer,
} from './styled';
import { GeneralLeasingData } from './components/generalLeasingData';
import { OperationalLeasingData } from './components/operationalLeasingData';
import { LeasingTypeInfo } from './components/common/leasingTypeInfo';
import { FinancialLeasingData } from './components/financialLeasingData';

export const LeasingInfoCalculation: React.FC<
  LeasingCalculatorSharedFormProps
> = (props) => (
  <CalculatorContainer>
    <ContentWrapper>
      <RowContainer>
        <GeneralLeasingData {...props} />
        <LeasingTypeInfo />
      </RowContainer>

      <RowContainer>
        <FinancialLeasingData {...props} />
        <OperationalLeasingData {...props} />
      </RowContainer>
    </ContentWrapper>
  </CalculatorContainer>
);
